export default function CoinRushIcon() {
  return (
    <svg viewBox="0 0 64 64" aria-hidden="true">
      <rect x="27" y="22" width="10" height="20" rx="2" fill="#3B434F" />
      <circle cx="13" cy="32" r="8" fill="#2F8BFF" />
      <circle cx="51" cy="32" r="8" fill="#FF8A1F" />
      <circle cx="22" cy="13" r="5" fill="#E7ECF3" />
      <circle cx="42" cy="51" r="5" fill="#E7ECF3" />
      <path d="M32 4 l7 7 l-7 7 l-7 -7 z" fill="#E7ECF3" />
      <path d="M32 46 l7 7 l-7 7 l-7 -7 z" fill="none" stroke="#E7ECF3" strokeWidth="2.5" strokeLinejoin="round" />
    </svg>
  );
}
